export const MOMENT_DATE_FORMAT: string = 'MM/DD/YYYY';
export const DATE_FORMAT = 'MMM dd, yyyy';
export const MONTH_YEAR_FORMAT = 'MMMM yyyy';
export const SHORT_MONTH_YEAR_FORMAT = 'MMM yyyy';
export const MONTH_DAY_YEAR_FORMAT = 'MMM DD, YYYY';
